import { changeSectionSettings } from 'legacy/lut/services/partner360/sectionSettings/changeSectionSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { Nullable } from 'cng-common/models/utils'
import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'

import { selectFinancialYear, selectPartnerId } from '../../configuration'
import { UPDATE_SECTION_SETTINGS } from '../constants'
import { IClientSectionSettings } from '../models/iSectionSettingsState'

interface IUpdateSectionSettingsParameters {
  sectionSettings?: Partial<IClientSectionSettings> // need to remove for every call
  controlName: 'SoB' | 'Planning' | 'Assortment'
  flag: string
  /** A 0/1 flag or the value itself (AVT, rounding). */
  state: Nullable<number | string>
  partnerId?: string
  fYear?: number
  /** Saved by the server as `<flag>-comment`, only with `saveExtendedInfo: 1`. */
  comment?: string
  /**
   * 1: the server writes `<flag>-user`, `<flag>-date` and `<flag>-comment`.
   * 0 or absent: the server deletes them.
   */
  saveExtendedInfo?: 1 | 0
}

export const updateSectionSettings = createAsyncThunk<
  Partial<IClientSectionSettings>,
  IUpdateSectionSettingsParameters
>(
  UPDATE_SECTION_SETTINGS,
  async (
    {
      state,
      flag,
      controlName,
      comment,
      saveExtendedInfo,
      partnerId: requestedPartnerId,
      fYear: requestedFYear,
    },
    { getState }
  ) => {
    const ownerId = compose(selectAppOwnerId, getState)()
    const partnerId = requestedPartnerId ?? compose(selectPartnerId, getState)()
    const fYear = requestedFYear ?? compose(selectFinancialYear, getState)()

    return changeSectionSettings({
      partnerId,
      fYear,
      ownerId,
      state,
      flag,
      controlName,
      comment,
      saveExtendedInfo,
    })
  }
)
